import React, { useRef } from 'react';
import { DocumentSubCategory, DocumentUploadCategory, PropertyDocument, SUBCATEGORY_LABELS } from 'types/Documents';
import Button from 'components/Button/Button';
import FileTypeIcon from 'components/Icons/FileTypeIcon';
import UploadSvg from 'assets/icons/upload.svg?react';
import FileIcon from 'assets/icons/fileThin.svg?react';
import { CategoryBadge, DoneBadge } from '../utils';
import { SUPPORTED_FILE_TYPES } from 'utils/documents';
import styles from '../NewOwnerOnboarding.module.css';

interface MonthlyRentRollItemProps {
    category: DocumentUploadCategory | undefined;
    monthlyRentRollDocuments: PropertyDocument[];
    uploadDocuments: (e: React.ChangeEvent<HTMLInputElement>, category: DocumentUploadCategory) => Promise<void>;
    disableInteractions: boolean;
}

function MonthlyRentRollItem({
    category: monthlyRentRollCategory,
    monthlyRentRollDocuments,
    uploadDocuments,
    disableInteractions,
}: MonthlyRentRollItemProps): JSX.Element {
    if (!monthlyRentRollCategory) return <></>;

    const rentRollInputRef = useRef<HTMLInputElement>(null);

    const uploadRentRollFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await uploadDocuments(e, monthlyRentRollCategory);
    };

    return (
        <div
            className={`${styles.item} ${
                monthlyRentRollDocuments.length > 0
                    ? styles.done
                    : monthlyRentRollCategory.is_required
                    ? styles.required
                    : ''
            }`}
        >
            <FileIcon className={styles.itemIcon} />
            <div>
                <div className={styles.titleRow}>
                    <span className={styles.itemTitle}>
                        {SUBCATEGORY_LABELS[DocumentSubCategory.MONTHLY_RENT_ROLL]}
                    </span>
                    <CategoryBadge category={monthlyRentRollCategory} />
                </div>
                <p className={styles.itemDescription}>Current tenants or monthly parkers and their rates.</p>
            </div>
            <div className={styles.actions}>
                {monthlyRentRollDocuments.length > 0 && <DoneBadge />}
                <input
                    ref={rentRollInputRef}
                    type="file"
                    hidden
                    multiple
                    accept={SUPPORTED_FILE_TYPES}
                    onChange={uploadRentRollFiles}
                />
                <Button
                    color="info"
                    size="sm"
                    onClick={() => rentRollInputRef.current?.click()}
                    className={styles.actionButton}
                    disabled={disableInteractions}
                >
                    <UploadSvg />
                    Upload
                </Button>
            </div>
            {monthlyRentRollDocuments.map((file, i) => (
                <div key={i} className={styles.fileItem}>
                    <FileTypeIcon fileType={file.file_type} size={20} />
                    <span className={styles.fileName}>{file.display_name}</span>
                </div>
            ))}
        </div>
    );
}

export default MonthlyRentRollItem;
